<template>
  <div class="mc-product-card" v-if="typeof product == 'object'">
    <ul class="mc-product-card__labels mc-labels">
      <li v-if="product.is_sale" class="mc-labels__item mc-labels__item--orange">
        sale
      </li>
      <li v-if="product.is_new" class="mc-labels__item mc-labels__item--black">
        new
      </li>
    </ul>
    <ul class="mc-product-card__tools mc-card-tools">
      <li class="mc-card-tools__item">
        <button @click="addToFavorite()"
          class="mc-card-tools__button simulated-hover" 
          :class="{ isFilled: counterFavoriteData && counterFavoriteData.ids && counterFavoriteData.ids.includes(product.id) }"
          type="button" 
          aria-label="Добавить в избранное">
          <svg class="mc-card-tools__icon" width="20" height="20" viewBox="0 0 20 20">
            <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
          </svg>
        </button>
      </li>
    </ul>
    <router-link class="mc-product-card__image-link" :to="'/detail/'+product.id+'/'">
      <img class="mc-product-card__image" :src="product.picture" width="158" height="262" :alt="product.name || ''">
    </router-link>
    <div class="mc-product-card__body">
      <div class="mc-product-card__title">
        <router-link class="mc-product-card__title-link" :to="'/detail/'+product.id+'/'">
          {{ product.name }}
        </router-link>
      </div>
      <div class="mc-product-card__price">
        <span v-if="product.price_old > product.price" class="mc-product-card__price-old">
          {{ product.price_old }}
        </span>
        <span class="mc-product-card__price-current">
          {{ product.price }} ₽
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['counterFavoriteData', 'counterBasketData'])
  },
  methods: {
    addToFavorite() {
      this.$store.dispatch('addToFavorite', this.product.id);
    }
  }
}
</script>